import {useState} from 'react';
import {Button, Icon, SelectInput, TextInput} from '@sabre/spark-react-core';
import {tAsString} from '../../../../../common/helpers/react/text/tAsString';
import styles from './AssigneesSearch.module.css';
import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import {SearchType} from '../../../../../common/model/types/assignees/SearchType';
import {
    asGroupParticipantType
} from '../../../../../common/helpers/converters/asGroupParticipantType';
import {asString} from '../../../../../common/helpers/converters/asString';
import {cssClasses} from '../../../../../common/helpers/browser/cssClasses';
import {AddRemoveInfo} from "../groups/wizard/agents-step/AddRemoveInfo";

export type AssigneesSearchProps = {
    groupId?: number,
    addRemoveInfo?: AddRemoveInfo
    initialSearchType?: SearchType,
    persistSearchValue?: boolean,
    onSearch?: () => void
}

export default function AssigneesSearch(props: AssigneesSearchProps) {
    const controllers = useControllers();
    const groups = controllers.groups;
    const agents = controllers.agents;

    const  agencySearchType = agents.getSearchType().useState();
    const persistedSearchValue = agents.getSearchPattern().useState() ?? '';

    const [type, setType] = useState(asString(props.initialSearchType ?? agencySearchType));
    const [searchValue, setSearchValue] = useState(props.persistSearchValue ? persistedSearchValue : '');

    const updateSearchValue = (value: string) => {
        setSearchValue(value);

        if (props.persistSearchValue) {
            agents.setSearchPattern(value);
        }
    };

    const closeButton = searchValue.length > 0
        ?
        <Icon
            className={cssClasses(
                styles.CloseButton,
                'qa-select-close-button')}
            iconStyle={'line'}
            name={'close'}
            role={'button'}
            onClick={() => updateSearchValue('')}
            aria-label={tAsString('CLEAR_TEXT_FIELD')}
            aria-hidden={false}
        />
        : <></>;

    const executeSearch = () => {
        const search = groups.searchForPossibleAssignees({
            searchCriteria: {
                type: asGroupParticipantType(type),
                pattern: searchValue
            }
        }, props.groupId, props.addRemoveInfo);

        props.onSearch?.();

        return search;
    };

    return (
        <div className={styles.SearchSection}>
            <h4 className={styles.Header}>{tAsString('SEARCH_BY')}</h4>
            <div className={'row'}>
                <div className={styles.InputsWrapper}>
                    <SelectInput
                        className={cssClasses(
                            styles.SelectInput,
                            'qa-search-select-input'
                        )}
                        label={tAsString('TYPE')}
                        name={'search_select_input'}
                        options={[
                            {
                                label: 'PCC',
                                value: SearchType.PCC
                            },
                            {
                                label: tAsString('COUNTRY'),
                                value: SearchType.COUNTRY
                            },
                            {
                                label: tAsString('AGENCY_NAME'),
                                value: SearchType.AGENCY_NAME
                            },
                            {
                                label: tAsString('SABRE_ID'),
                                value: SearchType.SABRE_ID
                            },
                            {
                                label: tAsString('AGENT_LAST_NAME'),
                                value: SearchType.AGENT_NAME
                            }
                        ]}
                        onChange={(e, value): void => {
                            setType(value);
                            agents.setSearchType(value);
                        }}
                        value={type}
                    />
                    <TextInput
                        className={cssClasses(
                            styles.TextInput,
                            'qa-search-text-input'
                        )}
                        name={'search_text_input'}
                        label={tAsString('SEARCH')}
                        value={searchValue}
                        onChange={(e, value): void => updateSearchValue(value)}
                        onKeyDown={(e) => e.key === 'Enter' && executeSearch()}
                    >
                        {closeButton}
                    </TextInput>
                </div>
                <div className={styles.SearchButtonWrapper}>
                    <Button
                        className={cssClasses(
                            styles.SearchButton,
                            'qa-search_button'
                        )}
                        textOnly={true}
                        onClick={executeSearch}
                    >
                        {tAsString('SEARCH')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
